import dmiLogo from "../assets/dmi-logo-reverse.svg";

interface BrandProps {
  compact?: boolean;
}

export function Brand({ compact = false }: BrandProps) {
  return (
    <div className={`brand ${compact ? "compact" : ""}`} aria-label="DMI Q Insight">
      <img className="brand-logo" src={dmiLogo} alt="DMI" />
      {!compact && (
        <span className="brand-copy">
          <strong>Q Insight</strong>
        </span>
      )}
    </div>
  );
}
